import React, { Component } from "react";
import { connect } from "react-redux";
import { css } from "aphrodite";
import CardSupport from "../../components/dasboard/CardSupport";
import CardDanaEstimasi from
  "../../components/dasboard/CardDanaEstimasiCabang";
import CardDanaCabang from "../../components/dasboard/CardDanaCabang";
import CardDanaMasuk from
  "../../components/dasboard/CardDanaMasukCabang";
import CardMemberCabang from
  "../../components/dasboard/CardMemberCabang";
import CardMaps from "../../components/dasboard/CardMapsCabang";
import { listBranch } from
  "../../actions/master-data/branch_action";
import { getDashboardData } from
  "../../reducers/dashboard/cabang_reducer";
import { dashboardGridStyles as s } from
  "../../components/dasboard/dashboardGridStyles";

class DashboardAdminCabang extends Component {
  render() {
    return (
      <>
        <CardMemberCabang />
        <div className={css(s.row)}>
          <div className={css(s.col75)}>
            <CardMaps />
          </div>
          <div className={css(s.col25)}>
            <CardSupport />
          </div>
        </div>
        <div className={css(s.row)}>
          <div className={css(s.col33)}>
            <CardDanaEstimasi />
          </div>
          <div className={css(s.col33)}>
            <CardDanaMasuk />
          </div>
          <div className={css(s.col33)}>
            <CardDanaCabang />
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps({
  listCandidate,
  listGraduated,
  listOrthopaedi,
  listSubspecialist,
}) {
  return {
    listCandidate_data: getDashboardData(listCandidate),
    listGraduated_data: getDashboardData(listGraduated),
    listOrthopaedi_data: getDashboardData(listOrthopaedi),
  };
}

export default connect(mapStateToProps, {
  listBranch,
})(DashboardAdminCabang);
